import { Injectable } from '@angular/core';
import { SearchAreaGroupApi } from '../../lib/apis/search-area-group/search-area-group.api';
import { SearchAreaGroup } from '../../models/search-area-group/search-area-group';
import { firstValueFrom } from '../../utils/first-value-from';

@Injectable({ providedIn: 'root' })
export class SearchAreaGroupRepository {
  constructor(private readonly api: SearchAreaGroupApi) {}

  async getAll(): Promise<SearchAreaGroup[]> {
    const res = await firstValueFrom(this.api.getAll());
    return res.map(
      item =>
        new SearchAreaGroup({
          id: item.id,
          index: item.index,
          key: item.key,
          name: item.name,
        }),
    );
  }
}
